import { render, staticRenderFns } from "./MusterilerDetay.vue?vue&type=template&id=e67d5e54&"
import script from "./MusterilerDetay.vue?vue&type=script&lang=js&"
export * from "./MusterilerDetay.vue?vue&type=script&lang=js&"
import style0 from "./MusterilerDetay.vue?vue&type=style&index=0&id=e67d5e54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports